import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Popover, PopoverTrigger, PopoverContent } from '../components/ui/popover'
import { Button } from '../components/ui/button'
import { Badge } from '../components/ui/badge'
import { Bell } from 'lucide-react'
import { useNotifications } from '@/hooks/useNotifications'
import NotificationItem from '@/components/NotificationItem'

const NotificationsPopover = () => {
  const navigate = useNavigate()
  const { notifications, unreadCount, loading, openNotification, reload } = useNotifications()
  const [open, setOpen] = useState(false)

  const displayCount = unreadCount > 99 ? '99+' : unreadCount

  const handleOpenChange = (nextOpen) => {
    setOpen(nextOpen)
    if (nextOpen) reload()
  }

  const handleNotificationClick = (n) => {
    setOpen(false)
    openNotification(n)
  }

  const handleViewAll = () => {
    setOpen(false)
    navigate('/notifications')
  }

  return (
    <Popover open={open} onOpenChange={handleOpenChange}>
      <PopoverTrigger asChild>
        <Button className="bg-blue-600 hover:bg-blue-700 text-white h-10 px-4" aria-label="Notifications">
          <Bell className="h-4 w-4" />
          {unreadCount > 0 && (
            <Badge className="ml-2 bg-red-500 text-white border-0 text-xs min-w-[20px] h-5 flex items-center justify-center">
              {displayCount}
            </Badge>
          )}
        </Button>
      </PopoverTrigger>

      <PopoverContent side="bottom" align="end" className="w-80">
        <div className="space-y-2">
          <div className="flex items-center justify-between">
            <div className="text-sm font-semibold">Notifications</div>
            <div className="text-xs text-gray-500">{notifications.length} recent</div>
          </div>

          <div className="max-h-60 overflow-auto">
            {loading ? (
              <div className="text-xs text-gray-500">Loading...</div>
            ) : notifications.length > 0 ? (
              notifications.slice(0, 8).map((n) => (
                <NotificationItem
                  key={n.id || n._id}
                  notification={n}
                  onClick={handleNotificationClick}
                  className="py-2 px-1"
                />
              ))
            ) : (
              <div className="text-xs text-gray-500">No notifications</div>
            )}
          </div>

          <div className="pt-2 border-t mt-2">
            <button
              className="text-xs text-blue-600 hover:underline"
              onClick={handleViewAll}
            >
              View all notifications
            </button>
          </div>
        </div>
      </PopoverContent>
    </Popover>
  )
}

export default NotificationsPopover
